import { RefinementList } from '@/domain/search/types'
import { isLocationPageType } from '@/domain/useCases/pageTypeCheck'
import { PageType } from '@/types/models/PageType.model'

export const shouldHideCallButton = ({
  pageType,
  currentRefinements
}: {
  pageType: PageType
  currentRefinements: Pick<RefinementList, 'locations'>
}): boolean => {
  return (
    (isLocationPageType(pageType) &&
      currentRefinements?.locations?.includes('California')) ||
    false
  )
}
